import React from 'react';
import { connect, useSelector } from "react-redux";
import Button from "components/button";
import IndexModal from "components/modal";
import { BUTTON_ICONS } from "../../variables/constants";
import { addActiveModal, removeActiveModal } from '../../redux/layout/layoutState';
import { useCRUDAccess } from "utils/useCRUDAccess";

function PopupButton({ id, activeModals, showModal, hideModal, title, label, icon, children, 
	btnClass, action, moduleId=0, modalWidth=900, modalContainerClass, ...rest }) {
	const Icon = icon ?? BUTTON_ICONS[label];
	const isVisible = useSelector(state => state.layout.activeModals.includes(id));
	const checkCRUDAccess = useCRUDAccess();
	
	const wrappedChildren = typeof children === "function"
    ? children({ closeModal: () => hideModal(id) })
    : React.Children.map(children, (child) =>
        React.isValidElement(child)
          ? React.cloneElement(child, { closeModal: () => hideModal(id) })
          : child
      );

	return (
		<>
			{(moduleId === 0 || checkCRUDAccess(moduleId, action)) && <>
			<Button
				extra={`crud-button ${btnClass}`}
				onClick={() => showModal(id)}
				aria-haspopup="dialog"
				aria-expanded={showModal}
				{...rest}
			>
				{Icon && <Icon />} {label}
			</Button>

			<IndexModal
				open={isVisible}
				onClose={() => hideModal(id)}
				title={title}
				footer={title ? title : null}
				width={modalWidth}
				modalContainerClass={modalContainerClass}
				>
				{wrappedChildren}
			</IndexModal>

			</>
			}
		</>
	);
}

const mapStateToProps = (state) => ({
	activeModals: state.layout.activeModals,
});

const mapDispatchToProps = (dispatch) => ({
	showModal: (id) => dispatch(addActiveModal(id)),
	hideModal: (id) => dispatch(removeActiveModal(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PopupButton);
